import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import {
  getTournamentDetailsApi,
} from "./TournamentController";
import { getMatchListByTournamentId } from "../Match/MatchController";
import { loaderStateTrue, loaderStateFalse } from "../../slices/mainSlice";
import MatchList from "../Match/components/MatchList";

const TournamentsMatches = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { language } = useSelector((state) => state.language);
  const { tournamentId } = useParams();

  const [tournamentDetails, setTournamentDetails] = useState({});
  const [matchList, setMatchList] = useState([]);

  console.log("tournamentDetailstournamentDetailstournamentDetails", tournamentDetails);
  console.log("matchListmatchListmatchListmatchListmatchListmatchList", matchList);

  useEffect(() => {
    getTournamentDetails();
    getMatchList();
  }, []);

  const getTournamentDetails = () => {
    try {
      dispatch(loaderStateTrue());
      getTournamentDetailsApi(tournamentId)
        .then((response) => {
          let responseData = response.data || {};
          setTournamentDetails(responseData);
          dispatch(loaderStateFalse());
        })
        .catch((error) => {
          console.log(error);
          dispatch(loaderStateFalse());
        });
    } catch (error) {
      console.log(error);
      dispatch(loaderStateFalse());
    }
  };

  const getMatchList = () => {
    try {
      dispatch(loaderStateTrue());
      let payload = {
        "id": tournamentId
      }
      getMatchListByTournamentId(payload)
        .then((response) => {
          let responseData = response.data || [];
          setMatchList(responseData);
          dispatch(loaderStateFalse());
        })
        .catch((error) => {
          console.log(error);
          dispatch(loaderStateFalse());
        });
    } catch (error) {
      console.log(error);
      dispatch(loaderStateFalse());
    }
  };

  return (
    <main class="main p-4 relative">
      <div class="flex flex-col">
        <div class="flex flex-wrap items-start gap-y-6 -mx-2">
          <div class="lg:w-4/6 w-full px-2">
            <div class="space-y-5">
              <div class="flex items-center gap-3">
                <button
                  className="size-10 rounded-lg border border-gray-200 flex justify-center items-center hover:bg-gray-100"
                  onClick={() => navigate(`/${language}/tournaments-events`)}
                >
                  <img src="../../assets/images/icons/arrow-left.svg" />
                </button>
                <h3 class="xl:text-2xl text-xl font-extrabold uppercase">
                  {tournamentDetails?.name}
                </h3>
              </div>

              <div class="relative text-white">
                <div class="rounded-xl absolute inset-0 bg-[#FF4B44] overflow-hidden">
                  <div class="absolute -skew-x-[20deg] w-[14vw] top-0 -right-10 bottom-0 bg-[#FF4B44] before:content-[''] before:absolute before:w-2/3 before:top-0 before:left-0 before:bottom-0 before:bg-black/30"></div>
                </div>
                <div class="relative h-full">
                  <div class="flex max-sm:flex-wrap gap-y-3 justify-between items-center w-full h-60 rounded-xl bg-cover bg-center" style={{
                    backgroundImage: `url(${tournamentDetails?.bannerImage})`
                  }}>
                    <div class="p-5 flex flex-col items-start justify-between [&_h1_strong]:text-primary-500 space-y-3 md:w-1/2 [&_strong]:text-primary-500">
                      <div class="flex gap-3">
                        <div class="flex items-center gap-x-4 w-32">
                          <img
                            src="../../assets/images/clubs/sb29.png"
                            alt=""
                          />
                        </div>

                        <div>
                          <h4 class="xl:text-4xl lg:text-3xl md:text-2xl text-xl font-extrabold uppercase">
                            {tournamentDetails?.name}
                          </h4>
                          <p>Lorem Ipsum is simply dummy text.</p>
                        </div>
                      </div>
                    </div>
                    <div class="lg:-mt-4 text-center max-w-72">
                      <img
                        src={require("../../assets/images/club-players/julienLe-cardinal.png")}
                        alt=""
                        class="w-full inline-block"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex items-center gap-3">
                <h3 className="xl:text-2xl text-xl font-extrabold uppercase">
                  {t("recentMatches")}
                </h3>
                <button className="btn btn-primary text-nowrap ml-auto">
                  {t("seeAll")}
                </button>
              </div>
              {matchList?.length === 0 ? <div>Loading</div> :
                <MatchList data={matchList} />}
            </div>
          </div>
          <div className="lg:w-2/6 w-full px-2 sticky top-20">
            <div className="space-y-5">
              <div className="relative rounded-xl overflow-hidden">
                <div className="rounded-xl absolute inset-0 bg-[#F5F5F5] overflow-hidden">
                  <div className="w-[15vw] h-[15vw] rounded-[50%] bg-[#F022AC] blur-[50px] absolute -top-[8vw] -left-10 opacity-50"></div>
                  <div className="w-[20vw] h-[20vw] rounded-[50%] bg-[#FB4A4A] blur-[50px] absolute -top-[5vw] -right-20"></div>
                </div>
                <div className="relative bg-cover bg-no-repeat bg-center h-full">
                  <div className="flex lg:justify-center justify-center max-sm:flex-wrap gap-y-3 w-full">
                    <div className="flex-none max-sm:w-1/2 max-lg:w-1/3 relative">
                      <img
                        src="assets/images/football-stadium.png"
                        alt=""
                        className="max-w-full lg:max-h-[276px] inline-block"
                      />
                    </div>
                  </div>
                  <div className="p-4 flex flex-col justify-between gap-6">
                    <div className="space-y-2">
                      <h4 className="lg:text-2xl md:text-xl text-lg font-black leading-none uppercase">
                        Create a new Match
                      </h4>
                      <p className="font-secondary font-semibold text-gray-400">
                        Lorem Ipsum is simply dummy text.
                      </p>
                    </div>
                    <div
                      className=""
                      onClick={() => navigate(`/${language}/create-match/${tournamentDetails._id}`)}
                    >
                      <button className="btn btn-primary text-nowrap ml-auto">
                        {t("seeAll")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="relative">
                <div className="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
                  <div className="absolute -skew-x-[20deg] w-[4vw] top-0 -left-12 bottom-0 bg-[#3D54AC]"></div>
                  <div className="absolute -skew-x-[20deg] w-[18vw] top-0 -right-12 bottom-0 bg-[#3D54AC] before:content-[''] before:absolute before:w-2/3 before:top-0 before:left-0 before:bottom-0 before:bg-black/10"></div>
                </div>
                <div className="relative bg-cover bg-no-repeat bg-center h-full">
                  <div className="flex lg:justify-center justify-center max-sm:flex-wrap gap-y-3 w-full">
                    <div className="flex-none max-sm:w-1/2 max-lg:w-1/3 lg:-mt-4 relative">
                      <img
                        src="assets/images/club-players/paris.png"
                        alt=""
                        className="max-w-full lg:max-h-[276px] inline-block"
                      />
                    </div>
                  </div>
                  <div className="absolute left-0 bottom-0 right-0 p-4 flex justify-between items-end gap-6 bg-gradient-to-t from-[#3D54AC] rounded-b-xl overflow-hidden">
                    <div className="">
                      <div className="space-y-2">
                        <div className="flex items-center gap-x-4">
                          <span className="px-3 py-1 inline-flex gap-1 items-center text-xs font-semibold text-white rounded-full bg-green-500">
                            <img
                              src="assets/images/icons/star-fill.svg"
                              alt="Star"
                              width="16"
                              className="icon-white"
                            />{" "}
                            4.5
                          </span>
                        </div>

                        <h4 className="lg:text-2xl md:text-xl text-lg font-black leading-none uppercase text-white">
                          Ousmane Dembélé
                        </h4>
                      </div>
                    </div>
                    <div className="">
                      <button className="btn btn-primary text-nowrap ml-auto">
                        {t("seeAll")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default TournamentsMatches;
